import Vue from 'vue'
import Router from 'vue-router'
import CONST from '../src/utils/const'

Vue.use(Router)


let pages = {
  public: {
    '/login': () => import('views/login'),
    '/loginCompany': () => import('views/login/login-company'),
    '/login/callback': () => import('views/login/callback'),
    '/sign-up': () => import('views/signUp'),
    '/forget-password': () => import('views/forgetPassword'),
    "/activity/activityDetail": () => import("views/activity/activityDetail"),

    // "/activity/activityDetail/:id": () => import("views/activity/activityDetail"),
    // '/sosDissmissContent': () => import("views/searchSos/sosDissmissContent"),
    '/sosDissmissContent': () => import("views/searchSos/sosDissmissContent"),
    '/humanSensorsMonitor/:id/:floor': () => import('views/humanSensorsMonitor'),
  },
  private: {
    "/users": () => import("views/users"),
    "/users/create": () => import("views/users/create"),
    "/users/edit/:id": () => import("views/users/edit"),
    "/roles": () => import("views/roles"),
    "/groups": () => import("views/groups"),
    "/forms": () => import("views/forms"),
    "/forms/create": () => import("views/forms/create"),
    "/forms/edit/:id": () => import("views/forms/edit"),
    "/forms/history/:id": () => import("views/forms/history"),
    "/forms/values/:layoutId": () => import("views/forms/values"),
    "/forms/values/create/:layoutId": () => import("views/forms/values/create"),
    "/forms/values/edit/:id/:layoutId": () => import("views/forms/values/edit"),
    "/functions": () => import("views/functions"),
    "/layouts": () => import("views/layouts"),
    "/layouts/create": () => import("views/layouts/create"),
    "/layouts/edit/:id": () => import("views/layouts/edit"),
    "/contents": () => import("views/contents"),
    "/picklists": () => import("views/picklists"),
    "/password": () => import("views/password"),
    "/swagger-ui": () => import("views/swagger-ui"),
    "/map/0": () => import("views/map"),
    "/map/1": () => import("views/map"),
    "/map/2": () => import("views/map"),
    "/map/3": () => import("views/map"),
    "/grid/0": () => import("views/grid"),
    "/grid/1": () => import("views/grid"),
    "/grid/2": () => import("views/grid"),
    "/grid/3": () => import("views/grid"),
    "/grid/4": () => import("views/grid"),
    "/grid/5": () => import("views/grid"),
    "/grid/6": () => import("views/grid"),
    "/grid/7": () => import("views/grid"),
    "/grid/8": () => import("views/grid"),
    "/grid/9": () => import("views/grid"),
    "/grid/10": () => import("views/grid"),
    "/grid/11": () => import("views/grid"),
    "/grid/12": () => import("views/grid"),
    "/grid/13": () => import("views/grid"),
    "/grid/14": () => import("views/grid"),
    "/grid/15": () => import("views/grid"),
    "/grid/16": () => import("views/grid"),
    "/grid/17": () => import("views/grid"),
    "/liveStreaming": () => import("views/liveStreaming"),
    "/streaming": () => import("views/streaming"),
    "/indextest": () => import("views/indextest"),
    "/indextest/views": () => import("views/indextest/views"),
    "/indextest/chart": () => import("views/indextest/chart"),
    // "/toiletMgt": () => import("views/toiletMgt"),
    "/toiletMgt/1": () => import("views/toiletMgt"),
    "/toiletMgt/2": () => import("views/toiletMgt"),
    "/toiletMgt/3": () => import("views/toiletMgt"),
    "/page9": () => import("views/page9"),
    // "/reportpage2": () => import("views/reportpage2"),
    "/reportpage3": () => import("views/reportpage3"),
    // "/reportpage4": () => import("views/reportpage4"),
    // "/reportpage5": () => import("views/reportpage5"),
    // "/reportpage6": () => import("views/reportpage6"),
    "/reportpage7": () => import("views/reportpage7"),
    "/reportpage8": () => import("views/reportpage8"),
    "/reportpage9": () => import("views/reportpage9"),
    // "/settingpage1": () => import("views/settingpage1"),

    "/visitorCenterOverView": () => import("views/visitorCenterOverView"),
    "/dashBoard": () => import("views/visitorCenterOverView/dashboard"),
    "/gisMap": () => import("views/visitorCenterOverView/gisMap"),
    "/scenicAreaInfo": () => import("views/scenicAreaInfo"),

    "/stpDashboard": () => import("views/stpDashboard"),
    "/stpDashboard/0": () => import("views/stpDashboard"),
    "/stpDashboard/1": () => import("views/stpDashboard"),
    "/stpDashboard/2": () => import("views/stpDashboard"),
    "/stpDashboard/3": () => import("views/stpDashboard"),
    "/stpDashboard/6": () => import("views/stpDashboard"),
    "/stpDashboard/12": () => import("views/stpDashboard"),
    "/stpDashboard/14": () => import("views/stpDashboard"),
    "/searchViolation": () => import("views/searchViolation"),
    "/searchCar": () => import("views/searchCar"),
    "/searchInform": () => import("views/searchInform"),
    "/searchToliet": () => import("views/searchToliet"),
    "/searchTolietCount": () => import("views/searchTolietCount"),
    "/searchSos": () => import("views/searchSos"),
    "/searchStayAverage": () => import("views/searchStayAverage"),
    "/scenicAreaSetting": () => import("views/scenicAreaSetting"),
    "/searchParkingLimit": () => import("views/searchParkingLimit"),
    "/basicSetting": () => import("views/basicSetting"),
    "/informSetting": () => import("views/informSetting"),
    "/permissionSetting": () => import("views/permissionSetting"),
    "/informMailList": () => import("views/informMailList"),
    "/apiList": () => import("views/apiList"),    
    "/deviceManage": () => import("views/deviceManage"), 
    "/deviceErrorList": () => import("views/deviceErrorList"), 
    "/deviceError":()=>import("views/deviceError"),
    "/holidayManage": () => import("views/holidayManage"), 
    "/carsInOut": () => import("views/carsInOut"), 
    "/searchAreaCar": () => import("views/searchAreaCar"),
    "/searchCentralPeopleCount": () => import("views/searchCentralPeopleCount"),
    "/searchPeopleAttribute": () => import("views/searchPeopleAttribute"),
    "/activity": () => import("views/activity"),
    "/searchActivity": () => import("views/searchActivity"),
    "/searchControl":()=>import("views/searchControl"),

  },
  shared: {
    // '/': () => import("views/home"),
    '/': () => import("views/visitorCenterOverView/dashboard"),
    '/403': () => import("views/403"),
  },
  private_layout_less: {
    // "/activity/activityDetail/:id": () => import("views/activity/activityDetail"),
    // "/hlstest": () => import("views/activity/hlstest"),
    "/downloadImg": () => import("views/searchViolation/downloadImg"),
    // "/humanSensorsMonitor/:id/:floor": () => import("views/humanSensorsMonitor"),

  }
}




function getUserDomain(){
  const domainName = window.location.host;
  if(domainName){
    return domainName
  }
}

function createRouterConfig() {
  const userDomain =  getUserDomain();
  // const allowedDomain = 'localhost:8081' //測試用
  const allowedDomain = CONST.ACTIVITY_CLOUD_DOMAIN 
  console.log('userDomain',userDomain);
 
  if(userDomain === allowedDomain){
    console.log('userDomain !== allowedDomain');
    return [ { path: '/',name: '/', component:  () => import("views/activity/activityDetail"), meta: { allowAnonymous: true } },
             { path: '*',redirect: '/'}]
  }else{
    return [...Object.keys(pages.public).map(a => ({ name: a, path: a, component: pages.public[a], meta: { allowAnonymous: true } })),
            ...Object.keys(pages.private_layout_less).map(c => ({ name: c, path: c, component: pages.private_layout_less[c]})),
             {
                path: "", component: () => import("views/shared/layout"), 
                children: [
                  ...Object.keys(pages.private).map(b => ({ name: b, path: b, component: pages.private[b] })),
                  ...Object.keys(pages.shared).map(b => ({ name: b, path: b, component: pages.shared[b], meta: { noPermission: true } })),
                  { name: '404', path: "*", component: () => import("views/404"), meta: { noPermission: true } }]
              }]
  }}

const router = new Router({
  mode: 'history',
  routes: createRouterConfig()
  
});

export default  router;